import { getWindowRef, HT_FROM_WIDGET_SIGNOUT, removeVisitorId } from "@hiptraveler/common";

/**
 * Manages the widget sign-out flag in localStorage and clears the visitor ID when requested.
 *
 * @param action - Determines the operation to perform:
 *   - 'prevent': sets a localStorage flag (HT_FROM_WIDGET_SIGNOUT) to indicate the widget should not sign the user out.
 *   - 'clear': if the flag does not exists, invokes removeVisitorId() to clear the visitor’s ID.
 */
export function manageWidgetSignOutFlag(action: 'prevent' | 'clear'): void {

  const storage = getWindowRef()?.localStorage;

  if (storage && action === 'prevent') {
    storage.setItem(HT_FROM_WIDGET_SIGNOUT, '1');
  }

  if (storage && action === 'clear' && !storage.getItem(HT_FROM_WIDGET_SIGNOUT)) {
    removeVisitorId()
  }
}
